import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiResponseModel } from '../shared/models/api-response.model';

@Injectable({
  providedIn: 'root'
})
export class BookingsService {

  constructor(private http: HttpClient) {}
  createBooking(body) {
    return this.http.post<ApiResponseModel>('api/booking', body);
  }
  getAllBookings() {
    return this.http.get<ApiResponseModel>('api/booking');
  }
}
